exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-tabs__header{margin:0}.el-tabs--bottom .el-tabs__header.is-bottom{margin-top:0}.el-tabs__nav-scroll{background-color:#fff}.el-tabs__item{font-weight:700;font-size:15px;padding:0 12px!important}.el-tabs__active-bar{display:none}.el-tabs__item.is-active,.el-tabs__item:hover{color:#ec1c1c}.el-tabs__nav-wrap:after{height:1px}.process_list{color:#606266;font-size:14px}.process_list .process_list_num{display:inline-block;width:14px;height:14px;line-height:14px;text-align:center;border:2px solid #606266;border-radius:50%;margin-right:6px}.process_list .icon_size{margin:0 20px;font-weight:700;font-size:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fe53aba4","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/console/seal.vue
// module id = aMO5
// module chunks = 7 30